module.exports = __webpack_public_path__ + "media/images/icn-check-28a6b73be50f88dbacf1bbc4652f63de.png";